module.exports = __webpack_public_path__ + "static/media/pascal.8571d371.svg";